import { Svg } from 'common/assets'
import {
  AnimatedImage,
  Container,
  ContantContainer,
  DesktopWrap,
  Dragonfly,
  DragonflyRight,
  ImageContainer,
  LinksList,
  MobileImagesWrap,
  MobileTextDescription,
  Title,
  TitleWrapper,
} from './styled'
import { useTranslation } from 'react-i18next'
import { useContext } from 'react'
import { LandingContext } from 'common/contexts/Landing/Landing'
import { baseURL } from 'models'
import { useNavigate } from 'react-router-dom'
import { Button } from 'components/buttons'
import { Config } from 'common/config'

export const BanquetMain = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation()
  const { landing } = useContext(LandingContext)
  const description = landing?.banketDescription?.find(
    el => el.lang === language,
  )?.value
  const navigate = useNavigate()
  return (
    <Container>
      <ContantContainer>
        <Dragonfly src={Svg.Dragonfly} />
        <TitleWrapper>
          <Title>{t('banquetTitle')}</Title>
        </TitleWrapper>
        <DragonflyRight src={Svg.Dragonfly} />
        <MobileImagesWrap $count={landing?.banketMainImages?.length}>
          {landing?.banketMainImages?.map((item, i) => (
            <AnimatedImage
              key={item}
              src={baseURL + '/public/' + item}
              alt={`photo` + i + 1}
            />
          ))}
        </MobileImagesWrap>
        <DesktopWrap>
          <ImageContainer>
            <AnimatedImage
              src={baseURL + '/public/' + landing?.banketMainImages?.[0]}
            />
            <p>{description}</p>
          </ImageContainer>
          <ImageContainer>
            <AnimatedImage
              src={baseURL + '/public/' + landing?.banketMainImages?.[1]}
            />
          </ImageContainer>
        </DesktopWrap>
        <LinksList>
          {landing?.banketTerms && (
            <Button.Text
              onClick={() =>
                window.open(
                  baseURL + '/public/' + landing?.banketTerms,
                  '_blank',
                )
              }>
              {t('conditions')}
            </Button.Text>
          )}
          {landing?.banketMenu && (
            <Button.Text
              onClick={() =>
                window.open(
                  baseURL + '/public/' + landing?.banketMenu,
                  '_blank',
                )
              }>
              {t('menu')}
            </Button.Text>
          )}
          <a
            className="phone"
            href={`tel:${Config.General.phone?.replace(/\D/g, '')}`}>
            {Config.General.phone?.replace(/\D/g, '')}
          </a>
          <a
            className="phone"
            href={`tel:${Config.General.phone2?.replace(/\D/g, '')}`}>
            {Config.General.phone2?.replace(/\D/g, '')}
          </a>
        </LinksList>
        <MobileTextDescription>{description}</MobileTextDescription>
      </ContantContainer>
    </Container>
  )
}
